import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useNotification } from '@ipc/ipc-components';
import {
  SUCCESS, WARNING, ERROR, INFO,
} from './NotificationTypes';

export const NotificationsAdapter = ({ notification, auth }) => {
  const [{
    infoNotification, warningNotification, errorNotification, successNotification,
  }] = useNotification();

  useEffect(() => {
    let durationArr;
    if (notification && auth.isAuthenticated()) {
      switch (notification.type) {
      case SUCCESS:
        successNotification(notification.message, notification.duration);
        break;
      case ERROR:
        durationArr = notification.message.match(/\n/g) || [];
        errorNotification(notification.message, 5 + durationArr.length);
        break;
      case WARNING:
        warningNotification(notification.message, notification.duration);
        break;
      case INFO:
        infoNotification(notification.message, notification.duration);
        break;
      default: {
        infoNotification(notification.message, notification.duration);
      }
      }
    }
  }, [notification]);

  return null;
};

NotificationsAdapter.propTypes = {
  notification: PropTypes.shape({
    type: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    duration: PropTypes.number,
  }),
  auth: PropTypes.objectOf(PropTypes.shape),
};
